"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDrawShader = void 0;
var shader_1 = __importDefault(require("../gl-utils/shader"));
var vbo_1 = __importDefault(require("../gl-utils/vbo"));
var build_shaders_1 = require("./build-shaders");
var drawVert = "uniform vec2 uBrushSize; //relative, in [0,1]x[0,1]\nuniform vec2 uBrushPos; //relative, in [0,1]x[0,1]\n\nattribute vec2 aCorner; //in {-1,+1}x{-1,+1}\n\nvarying vec2 toCenter;\n\nvoid main(void) {\n    toCenter = -aCorner;\n\n    vec2 pos = uBrushPos + aCorner * uBrushSize;\n\n    gl_Position = vec4(2.0 * pos - 1.0, 0, 1);\n}";
var drawFrag = "precision mediump float;\n\nuniform float uThickness; //relative to brushRadius\n\nvarying vec2 toCenter;\n\nvoid main(void) {\n    float dist = length(toCenter);\n    if (dist < 1.0-uThickness || dist > 1.0)\n        discard;\n\n    const vec3 color = vec3(1);\n\n    gl_FragColor = vec4(color, 1.0);\n}";
var drawSrc = new build_shaders_1.ShaderSrc(drawVert, drawFrag);
function buildDrawShader(gl) {
    var shader = new shader_1.default(gl, drawSrc.vert, drawSrc.frag);
    shader.a["aCorner"].VBO = vbo_1.default.createQuad(gl, -1, -1, +1, +1);
    return shader;
}
exports.buildDrawShader = buildDrawShader;
